import { Filters, FilterCode } from "interfaces/filterContext";
import filterCodes from "../context/filterContext/sample-codes";
import filters from "../context/filterContext/sample-filters";

/**
 * Computes the available filters based on the selected filters and filterKeyMapping.
 * @param selectedFilters - The currently selected filters.
 * @param filterKeyMapping - The mapping between filterCodes keys and filters keys.
 * @returns The dynamically computed available filters.
 */
export const computeAvailableFilters = (
    selectedFilters: Record<string, string | undefined>,
    filterKeyMapping: Record<string, string>
): Record<string, { code: string | number; desc: string }[]> => {
    // Cast filters to the Filters type
    const typedFilters = filters as Filters;

    // If no filters are selected, return the entire list of filters
    if (Object.keys(selectedFilters).length === 0) {
        return { ...typedFilters }; // Return a copy of the original filters
    }

    let filteredOptions: Record<string, { code: string | number; desc: string }[]> = {};

    // Initialize filteredOptions with all filter groups from filters
    Object.keys(typedFilters).forEach((groupKey) => {
        filteredOptions[groupKey] = [...typedFilters[groupKey]]; // Copy all options for the group
    });

    // Apply filtering logic based on selected filters and filterCodes
    Object.keys(selectedFilters).forEach((selectedKey) => {
        const selectedValue = selectedFilters[selectedKey];
        if (selectedValue) {
            const mappedKey = filterKeyMapping[selectedKey]; // Map `filterCodes` key to `filters` group key
            filteredOptions = Object.keys(filteredOptions).reduce((acc, filterGroupKey) => {
                acc[filterGroupKey] = filteredOptions[filterGroupKey].filter((option) =>
                    filterCodes.some((code: FilterCode) => {
                        // Ensure selectedKey and mappedKey are valid keys of FilterCode
                        return (
                            code[selectedKey as keyof FilterCode] === parseInt(selectedValue) &&
                            code[mappedKey as keyof FilterCode] === option.code
                        );
                    })
                );
                return acc;
            }, {} as Record<string, { code: string | number; desc: string }[]>);
        }
    });

    console.log('--==>', filteredOptions);

    return filteredOptions;
};